import { AUTO_AIM_RANGE } from '../core/config';
import type { Content } from '../data/schema';

/** Marge (px) ajoutée à la portée d'une attaque de mêlée : le coup touche aussi par le rayon du monstre. */
export const MELEE_AUTOHIT_MARGIN = 60;

export interface Positioned { kind: string; alive: boolean; x: number; y: number; height: number; }

/** Portée utile du sort principal pour l'Autohit : portée de la mêlée (plus une marge), sinon la visée automatique du coeur. */
export function autoHitRange(content: Content, classId: string): number {
  const cls = content.classes[classId];
  const fx = cls ? content.spells[cls.primarySpell]?.effects[0] : undefined;
  return fx?.type === 'melee' ? fx.range + MELEE_AUTOHIT_MARGIN : AUTO_AIM_RANGE;
}

/**
 * Vrai s'il existe un monstre vivant à moins de `range` (par défaut AUTO_AIM_RANGE) du joueur (distance des pieds du joueur
 * au centre du corps du monstre, comme dans le coeur) : l'Autohit (tir automatique mobile) ne part alors jamais dans le vide.
 */
export function hasAutoAimTarget(entities: readonly Positioned[], range = AUTO_AIM_RANGE): boolean {
  const player = entities.find((e) => e.kind === 'player' && e.alive);
  if (!player) return false;
  return entities.some((e) => {
    if (e.kind !== 'monster' || !e.alive) return false;
    const d = Math.hypot(e.x - player.x, e.y - e.height / 2 - player.y);
    return d >= 1 && d <= range;
  });
}
